import React, { useState, Fragment } from 'react';
import vid from '../../assets/island.mp4'
import './Home.css'
import Axios from 'axios'
import {baseUrl} from '../../config/constants'


const Home = () => {
    const [site, setSite] = useState('')
    const [data, setData] = useState('')
    const [err, setErr] = useState('')
    const [ifempty, setIfempty] = useState(false)
    const handleChange = (e) => {
        setSite(e.target.value)
    }
    const [loading, setLoading] = useState(false)
    const handleSumbit = () => {
        setData('')
        setErr('')
        if(site){
        setData('')
        setErr('')
        setIfempty(false)
        setLoading(true)
      Axios.post('https://simdan-url.herokuapp.com/api/item', {originalUrl:site, baseUrl})
      .then(res => {
          setData(res.data)
          setLoading(false)
          console.log(res.data)
      })
      .catch(e => {
          if(e.message === 'Network Error'){
              setErr('Network Error, check your network connection')
            }
            else if(e.response.data){
                setErr(e.response.data)
            }
           else {
              console.log(e.response)
              setErr(e.message)
          }
          setLoading(false)
      })
        } else {
            setIfempty(true)
        }
    }

    // if(loading){
    //     return(
    //         <div className='loading'></div>
    //     )
    // }
    return (
        <div className='Homepage' >
            {/* <div className='Home_Header' >
                <Header/>
            </div> */}
            <div className='bg-bg' >
                <header className='bg-video'>
                    <video className='bg-video__content' autoPlay loop >
                        <source src={vid} ></source>
                    </video>
                </header>
            </div>
            <div className='Homepage__content'>
                <h1 className='Homepage__text' >Place your url here</h1>
                <input required value={site} onChange={handleChange} />
                {!loading ? 
                <Fragment>
                <a onClick={handleSumbit} class="btn btn-white btn-animated">Shorten</a>
                {data && (
                <div className='linksuccess' >
                    Shortened Url is ->{` `}
                    <a target="blank" href={data.shortUrl}>
                    {data.shortUrl}
                    </a>
                </div>
                )}
                {err && (
                <div className="shorten-title">
                    <p className='errmssg' >
                        Error occurred, can't shorten link <span>({err})</span>
                    </p>
                    
                </div>
                )}
                </Fragment>
                : 
                <div className="loader">
                    <div className="preloader-wrapper small active">
                    <div className="spinner-layer spinner-green-only">
                        <div className="circle-clipper left">
                        <div className="circle" />
                        </div>
                        <div className="gap-patch">
                        <div className="circle" />
                        </div>
                        <div className="circle-clipper right">
                        <div className="circle" />
                        </div>
                    </div>
                    </div>
                </div>
                }
            </div>
            
            


            {ifempty && (
            <div className="formError">Please enter a valid url</div>
            )}
            
        </div>
    )
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home/Home.js